<div class="dataview">
  <div class="summary-container">
    <div class="data-results-summary">
      <span *ngIf="!showOnlySelected"
            class="results-count">{{totalCount}} items</span>
      <span *ngIf="showOnlySelected"
            class="results-count">{{selectedCount}} selected</span>
      <ng-container *ngIf="allowSelection && hasSelected && !showOnlySelected">
        <div class="results-selected">
          <div title="{{ selectedCount }} selected"
               class="datex-text">({{ selectedCount }} selected)</div>
          <button (click)="onClearSelectionClicked()"
                  class="datex-button">
            <div class="button-label">
              <div class="button-icon"><i class="icon icon-ic_fluent_dismiss_20_regular"></i></div>
              <div class="button-text"></div>
            </div>
          </button>
        </div>
      </ng-container>
    </div>
  </div>
  <div class="dataview-tools">
    <ng-content select="[toolbar]"></ng-content>
    <div class="toolContainer">
      <mat-slide-toggle *ngIf="showSelectedOnlyToggle"
                        class="datex-toggle centered-content margin-left-0"
                        [checked]="showOnlySelected"
                        (change)="onShowOnlyToggleChange($event)">Show selected only</mat-slide-toggle>
    </div>
    <ng-container *ngIf="showDateFilter">
      <div class="date-filter">
        <label>From: </label>
        <input #input
               matInput
               autocomplete="off"
               [matDatepicker]="pickerFrom"
               (dateChange)="onValueChanged('dateFrom', $event)"
               [readonly]="true"
               [formControl]="datePickerControlFrom"
               class="datex-datebox datex-datecontainer">
        <mat-datepicker-toggle matSuffix
                               [for]="pickerFrom">
          <i matDatepickerToggleIcon
             class="icon icon-ic_fluent_calendar_20_regular"></i>
        </mat-datepicker-toggle>
        <mat-datepicker #pickerFrom
                        panelClass="datex-calendarpicker"></mat-datepicker>
      </div>

      <div class="date-filter">
        <label>To: </label>
        <input #input
               matInput
               autocomplete="off"
               [matDatepicker]="pickerTo"
               (dateChange)="onValueChanged('dateTo', $event)"
               [readonly]="true"
               [formControl]="datePickerControlTo"
               class="datex-datebox datex-datecontainer">
        <mat-datepicker-toggle matSuffix
                               [for]="pickerTo">
          <i matDatepickerToggleIcon
             class="icon icon-ic_fluent_calendar_20_regular"></i>
        </mat-datepicker-toggle>
        <mat-datepicker #pickerTo
                        panelClass="datex-calendarpicker"></mat-datepicker>
      </div>
    </ng-container>

    <div *ngFor="let filter of comboFiltersMap | keyvalue"
         class="field-container">
      <mat-select name="filter.key"
                  required
                  [id]="filter.key"
                  class="datex-selectcontainer"
                  disableOptionCentering
                  placeholder="{{filter.key}}"
                  (selectionChange)="changeComboFilter($event)"
                  panelClass="dropdown-below datex-dropdownpanel">
        <mat-option [value]="null"></mat-option>
        <mat-option *ngFor="let filterValue of filter.value"
                    [value]="filterValue"
                    class="datex-dropdownoption">
          {{filterValue.name}}
        </mat-option>
      </mat-select>
    </div>

    <div *ngIf="showFilter"
         class="query-filter">
      <!-- disable filter for now when show only selected is on -->
      <input matInput
             autocomplete="off"
             class="datex-textbox query-search"
             spellcheck="false"
             placeholder="Filter"
             [(ngModel)]="fullTextSearch"
             [disabled]="showOnlySelected || !items"
             (ngModelChange)="onFilterInputChanged()">
    </div>
  </div>

  <div class="dataview-grid styled-grid">
    <div class="grid-container"
         [ngClass]="{'fit-content-table': fitContents}">
      <div class="grid-table grid-table-striped">
        <div class="grid-table-header">
          <div *ngIf="allowSelection"
               class="grid-table-cell-header grid-table-cell-checkbox"></div>
          <div *ngFor="let columnDef of columnDefs"
               class="grid-table-cell-header">
            <ng-container *ngIf="columnDef.headerCell; else defaultColumnHeaderName">
              <ng-container *ngTemplateOutlet="columnDef.headerCell.template">
              </ng-container>
            </ng-container>
            <ng-template #defaultColumnHeaderName>
              {{columnDef.name}}
            </ng-template>
          </div>
          <div *ngIf="rowCommandTemplateRef"
               class="grid-table-cell-header grid-table-cell-header-command single"
               title=""></div>
        </div>

        <div *ngFor="let item of items; let index = index;"
             class="grid-table-row"
             [ngClass]="{'selected-row': isSelected(item), 'from-base-config': item.isFromBaseConfiguration }">

          <div *ngIf="allowSelection"
               class="grid-table-cell-data grid-table-cell-checkbox"
               [ngClass]="{'show_on_mouse_over': !isSelected(item)}">
            <mat-checkbox [checked]="isSelected(item)"
                          color="primary"
                          class="datex-checkbox"
                          (change)="onCheckBoxChanged($event, item)">
            </mat-checkbox>
          </div>

          <div *ngFor="let columnDef of columnDefs"
               class="grid-table-cell-data">
            <ng-container *ngTemplateOutlet="columnDef.cell.template; context: {$implicit: item}">
            </ng-container>
          </div>

          <div *ngIf="rowCommandTemplateRef"
               class="grid-table-cell-data grid-table-cell-command">
            <button class="grid-command datex-button"
                    [matMenuTriggerFor]="menu">
              <i class="icon icon-ic_fluent_more_horizontal_20_regular"></i>
            </button>
            <mat-menu #menu="matMenu"
                      class="options-menu">
              <ng-container *ngTemplateOutlet="rowCommandTemplateRef;
                      context: {$implicit: item }">
              </ng-container>
            </mat-menu>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div *ngIf="!showOnlySelected"
       class="pagination-container">
    <div *ngIf="pagesCount > 1"
         class="pagination">
      <span>
        {{currentPageFrom}}
        to
        {{currentPageTo}} of {{totalCount}}
      </span>
      <a (click)="goToPage(1)"><i class="icon icon-ic_fluent_previous_20_regular"></i></a>
      <a (click)="goToPage(currentPage - 1)"><i class="icon icon-ic_fluent_triangle_left_20_regular"></i></a>
      <span>Page {{currentPage}} of {{pagesCount}}</span>
      <a (click)="goToPage(currentPage + 1)"><i class="icon icon-ic_fluent_triangle_right_20_regular"></i></a>
      <a (click)="goToPage(pagesCount)"><i class="icon icon-ic_fluent_next_20_regular"></i></a>
    </div>
  </div>
</div>